import { OrderPropertyReport, SellingCompanyReport } from 'tms-lib';
import { PurchaseOrderLineReport } from './purchase-order-line-report';
import { PurchaseOrderDeliveryReport } from './purchase-order-delivery-report';
import { PurchaseOrderExtraReport } from './purchase-order-extra-report';
import { PurchaseOrderVatAnalysis } from './purchase-order-vat-analysis';

export interface PurchaseOrderReport {
  id: string;
  orderNo: number;
  orderType: string;
  supplierKey: string;
  supplierName: string;
  supplierOrderNo: string;
  supplierOrderRef: string;
  supplierConfirmationEmailAddress: string;
  currency: string;
  currencySymbol: string;
  dateOrdered: Date;
  dateOrderedString: Date;
  enteredBy: string;
  supplierAddress: string;
  supplierAddressHtml: string;
  deliveryAddress: string;
  deliveryAddressHtml: string;
  deliveryAddressee: string;
  orderedBy: string;
  paymentTerms: string;
  deliveryTerms: string;
  modeOfTransport: string;
  shipper: string;
  nettValue: number;
  taxValue: number;
  taxRate: number;
  overallValue: number;
  notes: string;
  shippingNotes: string;
  documentNotes: string;
  attachSpecPrintToPurchaseOrder: boolean;
  showBillOfMaterialItems: boolean;
  showFabricProcessings: boolean;
  salesOrderNo: string;
  salesOrderReference: string;
  datePrinted: string;
  printedBy: string;
  duplicateDocument: string;
  showVatAnalysisOnDocuments: boolean;

  sellingCompany: SellingCompanyReport;
  purchaseOrderLines: PurchaseOrderLineReport[];
  purchaseOrderDeliveryItems: PurchaseOrderDeliveryReport[];
  purchaseOrderExtraItems: PurchaseOrderExtraReport[];
  purchaseOrderVatAnalysis: PurchaseOrderVatAnalysis[];
  purchaseOrderProperties: OrderPropertyReport[];
}
